"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultNavExpandedState = getDefaultNavExpandedState;
exports.default = exports.NAV_EXPANDED_STATES = exports.MEDIA_QUERIES = void 0;

var _react = require("react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MEDIA_QUERIES = ['(max-width: 449px)', '(min-width: 450px) and (max-width: 1279px)', '(min-width: 1280px)'];
exports.MEDIA_QUERIES = MEDIA_QUERIES;
var NAV_EXPANDED_STATES = {
  COLLAPSED_XY: 'COLLAPSED_XY',
  COLLAPSED_X: 'COLLAPSED_X',
  EXPANDED: 'EXPANDED'
};
exports.NAV_EXPANDED_STATES = NAV_EXPANDED_STATES;

/**
 * The default for the nav expanded state is based on the current window size.
 *
 * @returns {TNavExpandedState}
 */
function getDefaultNavExpandedState() {
  switch (true) {
    case window.matchMedia(MEDIA_QUERIES[2]).matches:
      return NAV_EXPANDED_STATES.EXPANDED;

    case window.matchMedia(MEDIA_QUERIES[1]).matches:
      return NAV_EXPANDED_STATES.COLLAPSED_X;

    case window.matchMedia(MEDIA_QUERIES[0]).matches:
    default:
      return NAV_EXPANDED_STATES.COLLAPSED_XY;
  }
}

function getNewNavExpandedState(navExpandedState) {
  var _NAV_EXPANDED_STATES$, _NAV_EXPANDED_STATES$2, _NAV_EXPANDED_STATES$3, _toggleMap;

  var toggleMap = (_toggleMap = {}, _defineProperty(_toggleMap, NAV_EXPANDED_STATES.EXPANDED, (_NAV_EXPANDED_STATES$ = {}, _defineProperty(_NAV_EXPANDED_STATES$, NAV_EXPANDED_STATES.EXPANDED, NAV_EXPANDED_STATES.COLLAPSED_X), _defineProperty(_NAV_EXPANDED_STATES$, NAV_EXPANDED_STATES.COLLAPSED_X, NAV_EXPANDED_STATES.EXPANDED), _defineProperty(_NAV_EXPANDED_STATES$, NAV_EXPANDED_STATES.COLLAPSED_XY, NAV_EXPANDED_STATES.EXPANDED), _NAV_EXPANDED_STATES$)), _defineProperty(_toggleMap, NAV_EXPANDED_STATES.COLLAPSED_X, (_NAV_EXPANDED_STATES$2 = {}, _defineProperty(_NAV_EXPANDED_STATES$2, NAV_EXPANDED_STATES.EXPANDED, NAV_EXPANDED_STATES.COLLAPSED_X), _defineProperty(_NAV_EXPANDED_STATES$2, NAV_EXPANDED_STATES.COLLAPSED_X, NAV_EXPANDED_STATES.EXPANDED), _defineProperty(_NAV_EXPANDED_STATES$2, NAV_EXPANDED_STATES.COLLAPSED_XY, NAV_EXPANDED_STATES.EXPANDED), _NAV_EXPANDED_STATES$2)), _defineProperty(_toggleMap, NAV_EXPANDED_STATES.COLLAPSED_XY, (_NAV_EXPANDED_STATES$3 = {}, _defineProperty(_NAV_EXPANDED_STATES$3, NAV_EXPANDED_STATES.EXPANDED, NAV_EXPANDED_STATES.COLLAPSED_XY), _defineProperty(_NAV_EXPANDED_STATES$3, NAV_EXPANDED_STATES.COLLAPSED_X, NAV_EXPANDED_STATES.EXPANDED), _defineProperty(_NAV_EXPANDED_STATES$3, NAV_EXPANDED_STATES.COLLAPSED_XY, NAV_EXPANDED_STATES.EXPANDED), _NAV_EXPANDED_STATES$3)), _toggleMap);
  var defaultNavExpandedState = getDefaultNavExpandedState();
  return navExpandedState ? toggleMap[defaultNavExpandedState][navExpandedState] : NAV_EXPANDED_STATES.COLLAPSED_XY;
}

function useNav() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultNavExpandedState = getDefaultNavExpandedState();

  var _useState = (0, _react.useState)({
    navExpandedState: options.defaultNavExpandedState || getNewNavExpandedState(),
    useDefaultNavExpandedState: !(options.defaultNavExpandedState || options.navExpandedState)
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      navExpandedState = _useState2$.navExpandedState,
      useDefaultNavExpandedState = _useState2$.useDefaultNavExpandedState,
      setNavState = _useState2[1];

  var updateNavState = (0, _react.useCallback)(function (updates) {
    setNavState(function (state) {
      return _objectSpread({}, state, {}, updates);
    });
  }, [setNavState]);
  var handleMediaQueryChange = (0, _react.useCallback)(function () {
    updateNavState({
      navExpandedState: getDefaultNavExpandedState()
    });
  }, [updateNavState]);
  (0, _react.useEffect)(function () {
    var windowMediaQueries = MEDIA_QUERIES.map(function (query) {
      return window.matchMedia(query);
    });
    windowMediaQueries.forEach(function (query) {
      query.addListener(handleMediaQueryChange);
    });
    return function () {
      windowMediaQueries.forEach(function (query) {
        query.removeListener(handleMediaQueryChange);
      });
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    if (useDefaultNavExpandedState) {
      updateNavState({
        navExpandedState: defaultNavExpandedState
      });
    }
  }, [defaultNavExpandedState, navExpandedState, updateNavState, useDefaultNavExpandedState]);
  (0, _react.useEffect)(function () {
    if (options.navExpandedState && navExpandedState !== options.navExpandedState) {
      setNavState({
        navExpandedState: options.navExpandedState,
        useDefaultNavExpandedState: false
      });
    }
  }, [navExpandedState, options.navExpandedState, setNavState]);
  var getExpanderButtonProps = (0, _react.useCallback)(function () {
    return {
      onClick: function onClick(event) {
        var newNavExpandedState = getNewNavExpandedState(navExpandedState);
        updateNavState({
          navExpandedState: newNavExpandedState,
          useDefaultNavExpandedState: options.navExpandedState ? false : defaultNavExpandedState === newNavExpandedState
        });

        if (options.onChangeNavExpandedState) {
          options.onChangeNavExpandedState(newNavExpandedState);
        }
      }
    };
  }, [defaultNavExpandedState, navExpandedState, options, updateNavState]);
  return (0, _react.useMemo)(function () {
    return {
      getExpanderButtonProps: getExpanderButtonProps,
      navExpandedState: navExpandedState
    };
  }, [getExpanderButtonProps, navExpandedState]);
}

useNav.mediaQueries = MEDIA_QUERIES;
useNav.navExpandedStates = NAV_EXPANDED_STATES;
var _default = useNav;
exports.default = _default;